import React, { useState } from "react";
import { ArrowLeft, Check } from "lucide-react";

const AddContactPanel = ({ contact, isOpen, onClose, onSave }) => {
  const [name, setName] = useState("");
  const [attrKey, setAttrKey] = useState("");
  const [attrValue, setAttrValue] = useState("");
  const [syncToPhone, setSyncToPhone] = useState(false);

  // Auto-fill the phone number directly (no country code)
  const phoneNumber = contact?.phone || "";

  const handleSave = () => {
    if (!name.trim()) {
      alert("Name is required");
      return;
    }

    const savedContact = {
      ...contact,
      name: name.trim(),
      isSaved: true,
      syncToPhone,
      attributes: [{ key: attrKey.trim(), value: attrValue.trim() }],
      phone: phoneNumber,
    };

    onSave(savedContact);

    // Reset form
    setName("");
    setAttrKey("");
    setAttrValue("");
    setSyncToPhone(false);
    onClose();
  };

  if (!contact) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-[200] ${
          isOpen ? "opacity-40" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />

      {/* Side Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-full md:w-[500px] bg-white shadow-2xl transform transition-transform duration-300 z-[250] ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="bg-[#008069] text-white p-5 flex items-center gap-3">
          <button
            onClick={onClose}
            className="hover:bg-white/20 p-2 rounded-full"
          >
            <ArrowLeft size={24} />
          </button>
          <h2 className="text-xl font-semibold">Add New Contact</h2>
        </div>

        {/* Content */}
        <div className="overflow-y-auto h-[calc(100%-64px)] p-6 space-y-6 text-gray-800">
          {/* Name Field */}
          <div>
            <label className="block text-gray-600 mb-1 font-medium">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#008069]"
              autoFocus
            />
          </div>

          {/* Attributes */}
          <div className="space-y-2">
            <label className="block text-gray-600 font-medium">Attributes</label>
            <div>
              <input
                type="text"
                value={attrKey}
                onChange={(e) => setAttrKey(e.target.value)}
                placeholder="Key"
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#008069]"
              />
            </div>
            <div>
              <input
                type="text"
                value={attrValue}
                onChange={(e) => setAttrValue(e.target.value)}
                placeholder="Value"
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#008069]"
              />
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-gray-600 mb-2 font-medium">Phone</label>
            <input
              type="text"
              value={phoneNumber}
              readOnly
              className="w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50 outline-none"
            />
            <p className="text-xs text-gray-500 mt-1">
              This phone number is on WhatsApp.
            </p>
          </div>

          {/* Sync Toggle */}
          <div className="flex items-center justify-between pt-4 border-t">
            <div>
              <p className="text-gray-800 font-medium">Sync contact to phone</p>
              <p className="text-xs text-gray-500">
                Add this contact to your phone’s address book
              </p>
            </div>

            <button
              onClick={() => setSyncToPhone(!syncToPhone)}
              className={`relative inline-flex h-6 w-12 items-center rounded-full ${
                syncToPhone ? "bg-[#25D366]" : "bg-gray-300"
              }`}
            >
              <span
                className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                  syncToPhone ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        </div>

        {/* Save Button */}
        <div className="absolute bottom-6 right-6">
          <button
            onClick={handleSave}
            className="w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:bg-[#20bd5a]"
          >
            <Check size={28} className="text-white" />
          </button>
        </div>
      </div>
    </>
  );
};

export default AddContactPanel;  
